export const SaveDraftModalContent = {
  header: 'Pick up where you left off',
  content:
    'You have saved progress for one or more transfer requests. Click "Finish & submit" to continue with a request, or click the trash can icon to delete a request. If you want to start a new request, click "Cancel".',
  columns: {
    initiator: 'Initiator',
    dateStarted: 'Date started',
    requestType: 'Request type',
    actions: 'Actions',
  },
  initiatorLabels: {
    client: 'You',
    crew: 'Vanguard',
  },
  cancel: 'Cancel',
  deleteDraftAriaLabel: 'Delete draft',
  retrieveDraftAriaLabel: 'Retrieve draft',
  loading: 'Loading drafts...',
};
